import { Component, Vue } from 'vue-property-decorator';
import WithRender from './customersms.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import { SmsDtoType } from './smsDtoType';

@WithRender
@Component({
  components: {
    Loading,
  },
})
export default class CustomerSms extends Vue {
  SmsDtoType: SmsDtoType = {} as SmsDtoType;
  busy = false;
  processing = false;

  mounted() {
    const receivers = this.$route.query.receivers;
    if (typeof receivers === 'string')
      this.SmsDtoType.receivers = receivers;
  }

  async onSendSms() {
    try {
      this.busy = true;
      this.processing = true;
      const response = await _axios.post(`${config.gateway}admin/api/Customer/sendSms`, this.SmsDtoType);
      this.$bvToast.toast("done", {
        title: 'Notification',
        variant: 'success',
        autoHideDelay: 5000,
      });
    } catch (error) {
      this.$bvToast.toast(error.response.data, {
        title: 'Notification',
        variant: 'danger',
        autoHideDelay: 5000,
      })
    }
    finally {
      this.busy = false;
      this.processing = false;
    }
  }
}
